import React, { FC } from 'react'

import { Spinner } from '@acorns/web-components'
import { isEmpty, isNil } from 'ramda'

import { StyledLoadingContainer } from '../../styled-components'

type Props = {
  portfolios: any
  isCryptoDataLoading?: boolean
}

export const FullScreenLoader = () => (
  <StyledLoadingContainer>
    <Spinner />
  </StyledLoadingContainer>
)

export const LoadingContainer: FC<Props> = ({
  children,
  portfolios,
  isCryptoDataLoading,
}) => {
  const shouldRenderLoader =
    isNil(portfolios) ||
    isEmpty(portfolios) ||
    isEmpty(portfolios[0]) ||
    isCryptoDataLoading
  return <>{shouldRenderLoader ? <FullScreenLoader /> : children}</>
}
